import React from 'react';
import { Col, Row } from 'tdesign-react';
import DescriptionItem from '@/components/DescriptionItem';

export default function BasicInfo({ detail = {} }) {
  return (
    <Row gutter={[0, 8]}>
      <Col span={6}>
        <DescriptionItem
          labelStyle={{ width: 'auto', marginRight: 10, fontSize: 14 }}
          valueStyle={{ fontSize: 14 }}
          label='订阅名'
          value={detail.subscription}
        />
      </Col>
      <Col span={6}>
        <DescriptionItem
          labelStyle={{ width: 'auto', marginRight: 10, fontSize: 14 }}
          valueStyle={{ fontSize: 14 }}
          label='Topic'
          value={detail.topic}
        />
      </Col>
      {detail.partition !== undefined && (
        <Col span={6}>
          <DescriptionItem
            labelStyle={{ width: 'auto', marginRight: 10, fontSize: 14 }}
            valueStyle={{ fontSize: 14 }}
            label='分区'
            value={detail.partition}
          />
        </Col>
      )}
    </Row>
  );
}
